import { render, staticRenderFns } from "./AffiliateRulesPage.vue?vue&type=template&id=09a9b3a2&scoped=true&lang=pug&"
import script from "./AffiliateRulesPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateRulesPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateRulesPage.vue?vue&type=style&index=0&id=09a9b3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a9b3a2",
  null
  
)

export default component.exports